import { NgModule } from "@angular/core";
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClientJsonpModule } from "@angular/common/http";
import { MalihuScrollbarModule } from "ngx-malihu-scrollbar";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { RouterModule, Routes, Router } from "@angular/router";
import { WeatherService } from "./services/weather.service";
import { SideNavService } from "./services/sidenav.service";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import {
  MatButtonModule,
  MatNativeDateModule,
  MatIconModule,
  MatSidenavModule,
  MatListModule,
  MatToolbarModule,
  MatDatepickerModule,
  MatFormFieldModule,
  MatInputModule,
  MatSliderModule,
  MatMenuModule
} from "@angular/material";
import { MatDialogModule } from '@angular/material/dialog';
import { CommonModule } from "@angular/common";
import "hammerjs";
import { SidebarModule } from "ng-sidebar";
import { SelectLocationComponent } from './components/select-location/select-location.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OwlModule } from 'ngx-owl-carousel';
import { NgxGalleryModule } from 'ngx-gallery';
import { ModalModule, BsModalService } from 'ngx-bootstrap/modal';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { ScrollEventModule } from 'ngx-scroll-event';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { NgxAudioPlayerModule } from 'ngx-audio-player';
import { SnackbarModule } from 'ngx-snackbar';
import { BrowserModule, Meta } from '@angular/platform-browser';
import { InViewportModule } from 'ng-in-viewport';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { VgCoreModule } from 'videogular2/core';
import { VgControlsModule } from 'videogular2/controls';
import { VgOverlayPlayModule } from 'videogular2/overlay-play';
import { VgBufferingModule } from 'videogular2/buffering';
import { VgStreamingModule } from 'videogular2/streaming';
import { ModalContentComponent } from './components/modal-content/modal-content.component';
import { BarRatingModule } from "ngx-bar-rating";
import { GalleryModule } from '@ngx-gallery/core';
import { LightboxModule } from '@ngx-gallery/lightbox';
import { VideoComponent } from './components/video/video.component';
import { LazyLoadImagesModule } from 'ngx-lazy-load-images';
import { LazyModule } from 'ngx-lazy';
import { RouteReuseStrategy } from '@angular/router';
import { CachingInterceptor } from './interceptors/caching-interceptor';
import { RequestCacheService } from "./services/request-cache.service";
import { filter } from "rxjs/internal/operators/filter";
import { LoginComponent } from './components/login/login.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgxIntlTelInputModule } from "ngx-intl-tel-input";
// import { ShareButtonsModule } from 'ngx-sharebuttons';
import { ShareButtonsModule } from '@ngx-share/buttons';
import { ShareButtonsConfig } from '@ngx-share/core';
// import  { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { NgNavigatorShareService } from 'ng-navigator-share';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { AddInsDirective } from "./directives/add-ins.directive";
import { AddComponent } from "./components/add/add.component";
import { MobileNsFiftyComponent } from "./components/mobile-ns-fifty/mobile-ns-fifty.component";
import { MobileNsThreeHundredComponent } from "./components/mobile-ns-three-hundred/mobile-ns-three-hundred.component";
import { RonMobileFullScreenComponent } from "./components/ron-mobile-full-screen/ron-mobile-full-screen.component";
import { RonMobileFootboardComponent } from "./components/ron-mobile-footboard/ron-mobile-footboard.component";
import { CpcCdcComponent } from "./components/cpc-cdc/cpc-cdc.component";
import { cpDcService } from "./services/cp-dc/cp-dc.service";
import { cpmService } from "./services/cp-dc/cpm.service";
import { ModalComponent } from "./components/modal/modal.component";
import { VideoInlineComponent } from "./components/modal/video-inline/video-inline.component";
import { AdIndexService } from "./services/index.service";
import { MusicModalComponent } from "./components/music-modal/music-modal.component";
import { VideoInlineComponent1 } from "./components/modal/video-inline1/video-inline.component";
import { FilterMenuPipe } from "./pipes/menu.pipe";
import { LoginSignupComponent } from "./components/login-signup/login-signup.component";
import { AuthService } from "./services/auth.service";
import { DeskAdComponent } from "./components/desktop-ad/desk-ad.component";
import { AuthGuard } from "./services/auth.guard";
import { AuthInterceptor } from "./services/auth.interceptor";
import { HeaderComponent } from "./components/header/header.component";
import { FooterComponent } from "./components/footer/footer.component";
import { ContactComponent } from "./Terms/contact/contact.component";
import { PrivacyComponent } from "./Terms/privacy/privacy.component";
import { AboutComponent } from "./Terms/about/about.component";
import { TermsComponent } from "./Terms/terms/terms.component";
import { AdvertiseComponent } from "./Terms/advertise/advertise.component";
import { DescriptionContentComponent, modalClose1 } from "./components/mobile/description-content/description-content.component";
import { SocialMenuComponent } from "./components/dt/social-menu/social-menu.component";
import { SideMenuLgComponent } from "./components/dt/side-menu-lg/side-menu-lg.component";
import { FixedContentComponent } from "./components/mobile/fixed-content/fixed-content.component";
import { DynamicContentComponent, modalClose } from "./components/mobile/dynamic-content/dynamic-content.component";
import { FixedContentComponentd } from "./components/dt/fixed-content/fixed-content.component";
import { DynamicContentComponentd } from "./components/dt/dynamic-content/dynamic-content.component";
import { DescriptionContentComponentd } from "./components/dt/description-content/description-content.component";
import { VideoInlineComponent2 } from "./components/video/video-inline2/video-inline.component";
//desktop import

//mobile import
//import { VgImaAdsModule } from 'videogular2/ima-ads';
// import { MVideoComponent } from "./components/mobile/m-video/m-video.component";
import { VideoAspectRatioDirective, VideoAspectRatioDirective1, VideoAspectRatioDirective2 } from "./directives/video-aspect-ratio.directive";
import { ShareComponent } from "./components/share/share.component";
import { ShareService } from "./services/share-service.service";
import { FancyBoxComponent } from "./components/fancy-box/fancy-box.component";
import { ImgeFilterPipe } from "./pipes/imge-filter.pipe";
import { FirstUrlPipe } from "./pipes/first-url.pipe";
import { ImgOriDirective } from "./directives/img-ori.directive";
import { SideMenuMobileComponent } from "./components/mobile/fixed-content/side-menu-mobile/side-menu-mobile.component";
import { MVideoComponent } from "./components/mobile/fixed-content/video/video.component";
import { LoginCommingSoonComponent } from "./components/login-comming-soon/login-comming-soon.component";
import { VgImaAdsModule } from "src/ima-ads/ima-ads";
import { PostTypePipe } from "./pipes/posttype.pipe";
import { EmbedComponent } from "./components/embed/embed.component";

const customConfig: ShareButtonsConfig = {
  include: ['whatsapp', 'linkedin', 'sms', 'messenger'],
  exclude: ['tumblr', 'stumble', 'mix', 'email', 'reddit', 'pinterest', 'telegram', 'line', 'vk', 'xing', 'print', 'copy', 'facebook', 'twitter'],
  theme: 'modern-light',
  gaTracking: true,
  twitterAccount: 'nightlifetv'
}
@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    ContactComponent,
    PrivacyComponent,
    AboutComponent,
    TermsComponent,
    AdvertiseComponent,
    FooterComponent,
    DescriptionContentComponent,
    LoginSignupComponent,
    DeskAdComponent,
    VideoInlineComponent,
    SocialMenuComponent,
    SideMenuLgComponent,
    FilterMenuPipe,
    FirstUrlPipe,
    VideoInlineComponent1,
    MusicModalComponent,
    AddComponent,
    MobileNsFiftyComponent,
    ModalComponent,
    CpcCdcComponent,
    RonMobileFootboardComponent,
    MobileNsThreeHundredComponent,
    RonMobileFullScreenComponent,
    FixedContentComponent,
    FixedContentComponentd,
    DynamicContentComponent,
    DynamicContentComponentd,
    SelectLocationComponent,
    DescriptionContentComponent,
    DescriptionContentComponentd,
    ModalContentComponent,
    FancyBoxComponent,
    VideoComponent,
    VideoInlineComponent2,
    LoginComponent,
    MVideoComponent,
    ShareComponent,
    LoginCommingSoonComponent,
    EmbedComponent,
    ImgeFilterPipe,
    SideMenuMobileComponent,
    VideoAspectRatioDirective,
    VideoAspectRatioDirective1,
    VideoAspectRatioDirective2,
    PostTypePipe,
    ImgOriDirective,
    AddInsDirective],

  exports: [
    CommonModule,
    MatButtonModule,
    MatToolbarModule,
    MatNativeDateModule,
    MatIconModule,
    MatSidenavModule,
    MatListModule,
    MatSliderModule,
  ],
  imports: [
    OwlModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    CommonModule,
    MatButtonModule,
    MatToolbarModule,
    MatNativeDateModule,
    MatIconModule,
    MatSidenavModule,
    MatListModule,
    MatDialogModule,
    ModalModule.forRoot(),
    MalihuScrollbarModule.forRoot(),
    SidebarModule.forRoot(),
    NgxGalleryModule,
    Ng4LoadingSpinnerModule.forRoot(),
    ScrollEventModule,
    NgbModule,
    NgxSpinnerModule,
    ButtonsModule.forRoot(),
    NgxAudioPlayerModule,
    NgxGalleryModule,
    SnackbarModule.forRoot(),
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    InViewportModule,
    MatSnackBarModule,
    VgCoreModule,
    VgControlsModule,
    VgOverlayPlayModule,
    VgBufferingModule,
    VgStreamingModule,
    ReactiveFormsModule,
    BarRatingModule,
    GalleryModule,
    LightboxModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    VgImaAdsModule,
    LazyLoadImagesModule,
    LazyModule,
    FontAwesomeModule,
    NgxIntlTelInputModule,
    MatSliderModule,
    MatDialogModule,
    MatMenuModule,
    ShareButtonsModule.withConfig(
      customConfig
    ),
    NgxSkeletonLoaderModule,
    // HttpClientJsonpModule,
    //NgxMaterialTimepickerModule
  ],
  providers: [
    AuthService,
    AuthGuard,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    WeatherService, AdIndexService, AuthService, ShareService, cpDcService, cpmService, SideNavService, BsModalService, modalClose, modalClose1, RequestCacheService, Meta, { provide: HTTP_INTERCEPTORS, useClass: CachingInterceptor, multi: true }],
  bootstrap: [AppComponent]
})
export class AppModule {



}